export default __webpack_public_path__ + "static/media/img_16.a2b964ed.webp";